import { useEffect, useState } from "react";
import api from "../api/api";

function RevenueSummary() {
  const [total,   setTotal]   = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/totalRevenue")
      .then(res => setTotal(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="stats-grid mb-24" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))" }}>
      <div className="stat-card gold">
        <span className="stat-emoji">₹</span>
        <div className="stat-value">{loading ? "…" : `₹${total}`}</div>
        <div className="stat-label">Total Revenue Collected</div>
      </div>
    </div>
  );
}

export default RevenueSummary;
